import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { ListingSaveWishlist } from "./ListingSaveWishlist";
import { BlogCardWebProvider } from "../../../blog/blogCard";
import { ListingSaveBlog } from "./ListingSaveBlog";

export const ListingSave = () => {
  const listingData = useSelector(
    (state: RootState) => state.trainingPlan.listingData,
  );

  if (listingData.blogId) {
    return (
      <BlogCardWebProvider blog={listingData}>
        <ListingSaveBlog />
      </BlogCardWebProvider>
    );
  }

  return <ListingSaveWishlist />;
};
